import type { ConversationMessage } from '@atlassian/unified-help-common/src/types';

export const getTotalSources = (message: ConversationMessage): number => {
	return message?.sources?.length ?? 0;
};
